import { useCallback, useEffect, useRef, useState } from 'react';

import { getSignedURL } from 'api/endpoints/upload';
import Preview from 'pages/SampleVideo/CreateSampleVideo/_components/Preview';
import { formatTime, handleVideoSurvey } from 'utils/helper';

const PlayVideo = require('assets/resources/PlayVideo.svg').default;
const VideoFile = require('assets/resources/VideoFile.svg').default;

const Video = ({ videoUrl, item, categoryName }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [currentIndex] = useState(0);
  const [duration, setDuration] = useState(0);
  const [sizeVideo, setSizeVideo] = useState({ width: 0, height: 0 });
  const videoRef = useRef(null);
  const [src, setSrc] = useState('');

  const setUpVideo = () => {
    if (videoRef.current) {
      setDuration(Math.floor(videoRef.current.duration));
    }
  };

  const handleGetWidthAndHeightVideo = useCallback(() => {
    if (videoRef.current) {
      const width = videoRef.current.offsetWidth;
      const height = videoRef.current.offsetHeight;
      setSizeVideo({ width, height });
    }
  }, [videoRef]);

  useEffect(() => {
    handleGetWidthAndHeightVideo();
  }, [handleGetWidthAndHeightVideo]);

  const handleLoadImage = useCallback(async () => {
    if (videoUrl) {
      setSrc(videoUrl);
    } else {
      const signedURL = await getSignedURL({ blob_name: item.source_blob || '', bucket_name: item.source_bucket || '' });
      const { signed_url, etag } = signedURL.data;
      const videos = await handleVideoSurvey([{ signed_url, etag }]);
      if (videos.length > 0) {
        videos[0]?.url_preview && setSrc(videos[0].url_preview);
      }
    }
  }, [item?.source_blob, item?.source_bucket, videoUrl]);

  useEffect(() => {
    handleLoadImage();
  }, [handleLoadImage]);

  return (
    <>
      <div className="flex flex-col gap-2 py-2">
        <div className="flex items-center gap-3 px-2">
          <img src={VideoFile} alt="video" />
          <p className="font-bold">{categoryName}</p>
        </div>
        <div className="relative rounded overflow-hidden h-[158px]">
          <video
            onLoadedMetadata={setUpVideo}
            onLoadedData={handleGetWidthAndHeightVideo}
            ref={videoRef}
            src={src}
            className="max-w-full max-h-[158px] m-auto object-center"
          />
          <div
            className="absolute font-bold text-white text-sm"
            style={{ left: `calc(((100% - ${sizeVideo.width}px) / 2) + 11px)`, bottom: `calc(((100% - ${sizeVideo.height}px) / 2) + 7.5px)` }}
          >
            <p>{formatTime(Math.floor(duration))}</p>
          </div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <img src={PlayVideo} alt="play video" className="cursor-pointer" onClick={() => setShowPreview(true)} />
          </div>
        </div>
      </div>
      {showPreview && (
        <Preview
          media_files={[
            {
              type: 'video',
              url: src,
            },
          ]}
          close={() => setShowPreview(false)}
          firstOpen={currentIndex}
        />
      )}
    </>
  );
};

export default Video;
